export const desktopHeaderLinks = [
  { name: "Home", url: "/" },
  { name: "About Us", url: "/about" },
  { name: "Services", url: "/services" },
  // { name: "Register", url: "/register" },
];

export const desktopFooterLinks = [
  { name: "Home", url: "/" },
  { name: "About Us", url: "/about" },
  { name: "Services", url: "/services" },
  { name: "Contact Us", url: "/contact" },
  // { name: "Register", url: "/register" },
];

export const legalLinks = [
  { name: "Privacy Policy", url: "/privacy" },
  { name: "Data Policy", url: "/data-policy" },
];

export const mobileMenuLinks = [
  { name: "Home", url: "/" },
  { name: "About Us", url: "/about" },
  { name: "Services", url: "/services" },
  // { name: "Register", url: "/register" },
];
